import React from 'react'
import { CADENCE_LABEL } from '~/service/Billing/billingConstants'

export default function ChangePlanTerms({ estimate, totalSeats, cadence }) {
  return (
    <p className='text-xs font-normal leading-relaxed text-llama-grey-7'>
      Your new subscription fee will be{' '}
      <span className='font-bold'>{estimate?.annual_price}</span> for{' '}
      <span className='font-bold'>{totalSeats} seats</span>{' '}
      <span className='font-bold'>{CADENCE_LABEL[cadence] ?? 'yearly'}</span>.
      {' '}This does not include applicable taxes or discounts. Your new subscription fee will
      apply to any subsequent recurring Subscription Fees during the remaining term of your
      agreement and at renewal. All changes are subject to your{' '}
      <a
        className='text-llama-purple-4 underline cursor-pointer'
        href='https://www.easyllama.com/terms'
        target='_blank'
        rel='noopener noreferrer'
      >
        Agreement
      </a>{' '}
      with Easyllama.Inc.
    </p>
  )
}
